import Honeybadger from '@honeybadger-io/js';

import { isStaging } from './env';
import { LUCKY } from '../editor-ui/constants';

export function sendMetric(metric, params) {
  // just print out the metric in dev mode
  if (process.env.NODE_ENV === 'development') {
    console.log(metric, params); // eslint-disable-line
  }
  if (!['production', 'test'].includes(process.env.NODE_ENV)) return; // comment out to test metrex locally with ce
  let url = import.meta.env.VITE_METREX_API_URL;
  if (isStaging()) {
    url = import.meta.env.VITE_METREX_API_STAGING_URL;
  }
  send(url, metric, params);
}

function send(url, metric, params) {
  try {
    fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        metric,
        params,
      }),
    });
  } catch (error) {
    Honeybadger.notify(error, 'Failed to send metric');
  }
}

export function constructVoiceNameForMetric(generatorVoiceUsed) {
  if (!generatorVoiceUsed?.voice) {
    return '';
  }

  let result = generatorVoiceUsed.voice;
  if (generatorVoiceUsed.user) {
    result = `user-${result}`;
  }
  if (generatorVoiceUsed.lucky) {
    result = `${LUCKY}: ${result}`;
  }
  return result;
}
